export type FilterTab = 'all' | 'pending' | 'warnings' | 'approved' | 'missing';

interface FilterTabsProps {
  active: FilterTab;
  onChange: (tab: FilterTab) => void;
  counts: Record<FilterTab, number>;
}

const TABS: { id: FilterTab; label: string }[] = [
  { id: 'all', label: 'All' },
  { id: 'pending', label: 'Pending' },
  { id: 'warnings', label: 'Warnings' },
  { id: 'approved', label: 'Approved' },
  { id: 'missing', label: 'Missing' },
];

export function FilterTabs({ active, onChange, counts }: FilterTabsProps) {
  return (
    <div className="filter-tabs" role="group" aria-label="Filter timesheets">
      {TABS.map((tab) => (
        <button
          key={tab.id}
          type="button"
          className={`filter-tab${active === tab.id ? ' filter-tab--active' : ''}`}
          aria-pressed={active === tab.id}
          onClick={() => onChange(tab.id)}
        >
          {tab.label}
          {counts[tab.id] > 0 && (
            <span className="filter-tab__badge" aria-label={`${counts[tab.id]} items`}>
              {counts[tab.id]}
            </span>
          )}
        </button>
      ))}
    </div>
  );
}
